import styled, { css } from 'styled-components';

import { pxToRem } from '../../../utils/styles';

export const Wrapper = styled.div<{ $widgetType?: string }>`
  &&& {
    overflow: hidden;
    position: relative;
    font-size: 16px;
    display: flex;
    flex-direction: column;
    gap: ${pxToRem(16)};
    height: 100%;
    ${({ $widgetType, theme: { mediaQueries } }) =>
      $widgetType === 'modal' &&
      (mediaQueries.isTablet || mediaQueries.isDesktop) &&
      css`
        padding: ${pxToRem(32)} ${pxToRem(24)};
      `}
  }
`;

export const HeaderWidget = styled.div`
  &&& {
    display: flex;
    align-items: center;
    justify-content: center;
    position: relative;
  }
`;

export const IconPosition = styled.div`
  &&& {
    position: absolute;
    top: 0;
    right: 0;
    cursor: pointer;
  }
`;

export const ConfirmWrapper = styled.div`
  &&& {
    position: absolute;
    left: 0;
    bottom: 0;
    background-color: ${({ theme }) => theme.colors.white};
    box-shadow: 0px -7px 24px -9px #0000003d;
    height: ${pxToRem(96)};
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
  }
`;

export const ButtonWrapper = styled.div`
  &&& {
    button {
      width: 100%;
    }
    flex-grow: 1;

    ${({ theme: { mediaQueries } }) =>
      mediaQueries.isDesktop &&
      css`
        max-width: ${pxToRem(200)};
      `}
  }
`;

export const Overflow = styled.div<{ $widgetType?: string }>`
  &&& {
    ${({ $widgetType }) =>
      $widgetType === 'modal' &&
      css`
        overflow: hidden;
        overflow: auto;
        scrollbar-width: none;
        overflow: auto;
        max-height: 80vh;
        padding-bottom: ${pxToRem(96)};
      `};
  }
`;
